import { createContext, useContext, useState, useEffect } from "react";
import { socket } from "../socket";

const PriceContext = createContext();

export const PriceProvider = ({ children }) => {
  const [prices, setPrices] = useState({});

  useEffect(() => {
    if (!socket.connected) socket.connect();

    const onPrice = (data) => {
      setPrices((prev) => ({
        ...prev,
        [data.symbol]: data?.data
,
      }));
    };

    socket.on("live_price", onPrice);

    return () => {
      socket.off("live_price", onPrice);
    };
  }, []);

  return (
    <PriceContext.Provider value={prices}>
      {children}
    </PriceContext.Provider>
  );
};

export const usePrices = () => useContext(PriceContext);
